
<style>
  .toolbar-custom {
    padding: 25px;
    background: #1a1a27;
    margin-bottom:30px;
  }
</style>
<div class="toolbar-custom">
  <div class="d-flex flex-stack">
    <div class="page-title d-flex align-items-center flex-wrap me-3">
      <ng-container>
        <!-- begin::Title -->
        <h1 class="d-flex align-items-center text-dark fw-bolder my-1 fs-3">
          {{SubheaderTitle}}
        </h1>
        <!-- end::Title -->
        <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
          <li class="breadcrumb-item">
            <ng-container>
              <a class="text-muted text-hover-primary" [routerLink]="Url" routerLinkActive="router-link-active">
                {{BreadcrumbTitle}}
              </a>
            </ng-container>
            <ng-container *ngIf="ShowBreadcrumbSecond">
              <span class="bullet bg-gray-200 w-5px h-2px"></span>
            </ng-container>
          </li>
          <li class="breadcrumb-item text-dark" *ngIf="ShowBreadcrumbSecond" [routerLink]="SecondUrl" routerLinkActive="router-link-active"> {{BreadcrumbTitleSecond}}</li>
        </ul>
      </ng-container>
    </div>


    <div class="d-flex align-items-center py-1">
      <!-- begin::Wrapper  -->
      <div class="me-4">
        <!-- begin::Menu  -->
        <ng-content *ngIf="ShowToolbar" select=".subheadertoolbar"></ng-content>

        <!-- end::Menu  -->
      </div>

      <!-- end::Button  -->
    </div>



  </div>
  <ng-content select=".filter-container"></ng-content>
</div>

